module.exports = __webpack_public_path__ + "static/media/banner.c9a2729e.jpg";